import { Controller } from '@hotwired/stimulus';
import { breakpoints } from '../utils/viewport_size_handler';

export default class extends Controller {
  static targets = ['container', 'zoneContent', 'noAutoInit'];

  static bannerBreakpoints = {
    mobile: `( max-width: ${breakpoints.xl - 1}px )`,
    desktop: `( min-width: ${breakpoints.xl}px )`,
  };

  static values = {
    fallbackUrl: String,
    fallbackImg: String,
    fallbackImgClasses: String,
    viewport: String,
    zoneId: Number,
    forwardParams: String,
    noAutoInit: { type: Boolean, default: false },
    hasLoadedOnce: { type: Boolean, default: false },
  };

  static responsiveBanners = [];
  static batchLoad = [];
  static batchBanners = [];
  static isBatchLoaded = false;

  isLoaded = false;

  static isGoaLoaded() {
    return !!window.Goa3;
  }

  loadFallbackContent() {
    if (!this.fallbackUrlValue || !this.fallbackImgValue) {
      return;
    }

    const img = document.createElement('img');
    img.src = this.fallbackImgValue;
    if (this.fallbackImgClassesValue) {
      img.classList.add(this.fallbackImgClassesValue);
    }

    const a = document.createElement('a');
    a.href = this.fallbackUrlValue;
    a.target = '_blank';
    a.appendChild(img);
    this.zoneContentTarget.appendChild(a);
  }

  static loadBatch() {
    window.goAdverticum3.onReady((goa3) => {
      const batched = this.batchBanners;
      goa3.invocation(this.batchLoad, () => {
        this.isBatchLoaded = true;
        batched.forEach((banner) => {
          banner.isLoaded = true;
        });
      });
    });
  }

  static afterLoad() {
    if (!this.isGoaLoaded()) {
      return;
    }

    this.loadBatch();
    this.handleViewportChange();
  }

  showBanner = () => {
    if (!this.constructor.isGoaLoaded()) {
      return;
    }

    if (this.noAutoInitValue && this.hasLoadedOnceValue) {
      return;
    }

    const bannerZoneObject = {
      node: this.zoneContentTarget,
      id: this.zoneIdValue,
      p: 70,
      fP: this.forwardParamsValue,
    };

    if (!this.constructor.isBatchLoaded) {
      this.constructor.batchLoad.push(bannerZoneObject);
      this.constructor.batchBanners.push(this);
    } else {
      window.goAdverticum3.onReady((goa3) => {
        if (this.isLoaded) {
          return;
        }
        this.isLoaded = true;
        goa3.invocation([bannerZoneObject], () => {
          if (this.noAutoInitValue) {
            this.hasLoadedOnceValue = true;
          }
        });
      });
    }
  };

  clearBanner = () => {
    if (this.noAutoInitValue) {
      return;
    }
    if (this.hasZoneContentTarget) {
      this.zoneContentTarget.innerHTML = '';
    }
    this.isLoaded = false;
  };

  static handleViewportChange() {
    let debounceTimer;
    window.matchMedia(this.bannerBreakpoints['desktop']).addEventListener('change', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        this.responsiveBanners.forEach((banner) => {
          banner.handleViewportSize();
        });
      }, 200);
    });
  }

  handleViewportSize() {
    const { matches } = window.matchMedia(this.constructor.bannerBreakpoints[this.viewportValue]);
    if (matches && !this.noAutoInitValue) {
      this.showBanner();
    }
  }

  initResponsiveBanner = () => {
    this.constructor.responsiveBanners.push(this);
    this.handleViewportSize();
  };

  initialize() {
    if (!this.constructor.isGoaLoaded()) {
      this.loadFallbackContent();
      return;
    }
    if (this.viewportValue) {
      this.initResponsiveBanner();
    } else if (!this.noAutoInitValue) {
      this.showBanner();
    }
  }
}
